import { easings } from "react-spring"

export const inflateFromBottom = {
  from: { opacity: 0, transform: "translate3d(0, 100%, 0)" },
  to: { opacity: 1, transform: "translate3d(0, 0%, 0)" },
  config: { duration: 250, easing: easings.easeInOut },
}

export const inflateFromLeft = {
  from: { opacity: 0, transform: "translate3d(-30%, 0, 0)" },
  to: { opacity: 1, transform: "translate3d(0, 0, 0)" },
  config: { duration: 250, easing: easings.easeInOut },
}

export const inflateFromRight = {
  from: { opacity: 0, transform: "translate3d(30%, 0, 0)" },
  to: { opacity: 1, transform: "translate3d(0, 0, 0)" },
  config: { duration: 250, easing: easings.easeInOut },
}

export const modalClose = {
  transform: "translate3d(30%, 0, 0)",
  opacity: 0,
}

export const modalOpen = {
  transform: "translate3d(0, 0, 0)",
  opacity: 1,
}
export const modalTransitionConfig = {
  duration: 250,
  easing: easings.easeInOut,
}

export const bounceFromBottom = {
  from: { opacity: 0, transform: "translate3d(0, -5%, 0)" },
  to: { opacity: 1, transform: "translate3d(0, -1%, 0)" },
  config: { tension: 30, friction: 7.5 },
}

export const fadeIn = {
  from: { opacity: 0.95 },
  to: { opacity: 1 },
  config: { duration: 250 },
}

export const fadeOut = {
  from: { opacity: 1 },
  to: { opacity: 0.95 },
  config: { duration: 250 },
}

export const imageTransitions = {
  from: {
    opacity: 0,
    position: "absolute",
  },
  enter: {
    opacity: 1,
  },
  leave: {
    opacity: 0,
  },
  config: { duration: 500 },
}
